import React, { forwardRef } from 'react';

import s from './ButtonSecondaryEllipse.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';

const ButtonSecondaryEllipse = forwardRef(
  (
    {
      asLink = false,
      children,
      active,
      disabled,
      onClick,
      size,
      alt = '',
      icon = 'icon-arrow-right-white',
      modifiers = [],
      isHovered = false,
      animateIcon = false,
      ...props
    },
    ref
  ) => {
    const rootClasses = classNames(
      s.Root,
      {
        [s.Active]: !!active,
        [s.Disabled]: !!disabled,
        [s.XSmall]: size === 'x-small',
        [s.Small]: size === 'small',
        [s.Large]: size === 'large',
        [s.Hover]: isHovered,
        [s.AnimateIcon]: animateIcon,
      },
      modifiers.map((m) => s[m])
    );

    return asLink ? (
      <Link {...props} ref={ref} onClick={onClick} className={rootClasses}>
        {icon && (
          <span className={s.IconWrap}>
            <span className={s.IconInner}>
              <Image
                width={22}
                height={22}
                src={`/img/${icon}.svg`}
                alt=""
                className={classNames(s.Icon, s.IconDefault)}
              />
              <Image
                width={22}
                height={22}
                src={`/img/${icon}.svg`}
                alt=""
                className={classNames(s.Icon, s.IconHover)}
              />
            </span>
            <i className={s.Bg} aria-hidden={true} />
          </span>
        )}
        {children}
      </Link>
    ) : (
      <button
        type="button"
        onClick={onClick}
        className={rootClasses}
        disabled={disabled}
        {...props}
        ref={ref}>
        {icon && (
          <span className={s.IconWrap}>
            <span className={s.IconInner}>
              <Image
                width={22}
                height={22}
                src={`/img/${icon}.svg`}
                alt=""
                className={classNames(s.Icon, s.IconDefault)}
              />
              <Image
                width={22}
                height={22}
                src={`/img/${icon}.svg`}
                alt=""
                className={classNames(s.Icon, s.IconHover)}
              />
            </span>
            <i className={s.Bg} aria-hidden={true} />
          </span>
        )}
        {children}
      </button>
    );
  }
);

ButtonSecondaryEllipse.displayName = 'ButtonSecondaryEllipse';
ButtonSecondaryEllipse.propTypes = {};

export default ButtonSecondaryEllipse;
